
export const pageTitleDefault = `Voila Catalog | An exceptional production music library for advertising`;
export const pageTitleAbout = `Voila Catalog About | Why we're crafting exceptional music for advertising`;


// WEBPACK FOOTER //
// ./src/constants.js